import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_get_editor_accessorial_charges_template_lines_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { template_id: number, full_text_search?: string }): 
  Promise<{ result: { Id?: number, BillingAccessorialChargeTemplateId?: number, OperationCodeId?: number, OperationCode?: { Id?: number, Name?: string, Uom?: number, BillingCode?: { Id?: number, Name?: string } }, measurements?: { Id?: number, Name?: string, Short_name?: string, TypeId?: number, Type?: { Name?: string } }[] }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.template_id)) {
      $missingRequiredInParams.push('\'template_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { template_id: number, full_text_search?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, BillingAccessorialChargeTemplateId?: number, OperationCodeId?: number, OperationCode?: { Id?: number, Name?: string, Uom?: number, BillingCode?: { Id?: number, Name?: string } }, measurements?: { Id?: number, Name?: string, Short_name?: string, TypeId?: number, Type?: { Name?: string } }[] }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.template_id)) {
      $missingRequiredInParams.push('\'template_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { template_id: number, full_text_search?: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, BillingAccessorialChargeTemplateId?: number, OperationCodeId?: number, OperationCode?: { Id?: number, Name?: string, Uom?: number, BillingCode?: { Id?: number, Name?: string } }, measurements?: { Id?: number, Name?: string, Short_name?: string, TypeId?: number, Type?: { Name?: string } }[] }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.template_id)) {
      $missingRequiredInParams.push('\'template_id\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      template_id: number, full_text_search?: string    }) {
        if(isNil($inParams.template_id)) {
          return true; 
        }
      return false;
    }
}
